<template>
  <article class="rc-content">
    <slot/>
  </article>
</template>
<script>
  export default {
    name: 'RcContent'
  }
</script>
<style lang="scss">
  @include b(content) {
    position: absolute;
    overflow: auto;
    top: 0;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;

    &[has-header] {
      top: $header-height;
    }

    &.margin-top {
      margin-top: 10px;
    }

    &[padding-top] {
      padding-top: 7px;
    }
  }
</style>
